export const STATES_MEX = [
  "AG",
  "BN",
  "BS",
  "CH",
  "CI",
  "CL",
  "CP",
  "CS",
  "DF",
  "DG",
  "GE",
  "GJ",
  "HD",
  "JA",
  "MC",
  "MR",
  "MX",
  "NA",
  "NL",
  "OA",
  "PU",
  "QE",
  "QI",
  "SI",
  "SL",
  "SO",
  "TA",
  "TB",
  "TL",
  "VC",
  "YU",
  "ZA"
];
